module.exports = __webpack_public_path__ + "static/media/publish.2671124b.png";